// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const PointsAndRewardsWrapper = styled(Anchor)`
  &.promotion-section-pdp-wrapper.promotion-section-pdp-wrapper {
    background: #f3f3f3;
  }
`;

export const DetailsLinkWrapper = styled(BodyCopy)`
  &.promotion-section-pdp-text.details-text {
    color: ${(props) => props.theme.colors.BLACK};
    text-decoration: underline;
  }
`;

export const PointsAndRewardsTextWrapper = styled(BodyCopy)`
  .points-and-rewards-1,
  .points-and-rewards-or,
  .points-and-rewards-2 {
    font-weight: 700;
  }

  .points-and-rewards-1 {
    color: ${(props) => props.theme.colors.PROMO.ORANGE};
    text-transform: uppercase;
  }
  .points-and-rewards-or {
    color: ${(props) => props.theme.colors.BLACK};
  }
  .points-and-rewards-2 {
    color: ${(props) => props.theme.colors.PROMO.BLUE};
    text-transform: uppercase;
  }
`;
